module.exports = {
  sites: {
    port: 80,
    hostname: 'qa.gallerysites.net',
  },
  liveStatus: {
    endpointBaseUrl: 'https://s3.amazonaws.com/bc-gallery-qa-assets/live-status',
  },
  edgeApi: {
    endpointBaseUrl: 'https://edge.api.qa.brightcove.com/playback/v1/accounts/',
  },
};
